import EdificioService from "@/api/services/finanzas/nomencladores/EdificioService"
import Vue from "vue"

const state = () => ({
    edificios: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    EDIFICIOS: state => {
        return state.edificios
    },
    EDIFICIOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_EDIFICIOS: (state, payload) => {
        state.edificios = payload
    },

    SET_EDIFICIOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_EDIFICIO: (state, payload) => {
        state.edificios.push(payload)
    },

    UPDATE_EDIFICIO: (state, payload) => {
        state.edificios = state.edificios.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_EDIFICIO: (state, payload) => {
        state.edificios = state.edificios.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_EDIFICIOS: async ({ commit, state }, { filter, edificioEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await EdificioService.get({ filter, edificioEstado, ...pagination })
            if (status === 200) {
                commit("SET_EDIFICIOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los edificios del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_EDIFICIOS: async ({ commit }) => {
        try {
            let { data, status } = await EdificioService.getAll()
            if (status === 200) {
                commit("SET_EDIFICIOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_EDIFICIOS: async ({ commit }) => {
        try {
            let { data, status } = await EdificioService.getAllRecords()
            if (status === 200) {
                commit("SET_EDIFICIOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los edificios del activo, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_EDIFICIO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EdificioService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_EDIFICIO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial para el edificio del activo, inténtelo nuevamente"
            })
        }
    },

    ADD_EDIFICIO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EdificioService.post(payload)
            if (status === 201) {
                commit("ADD_EDIFICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El edificio del activo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el edificio del activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_EDIFICIO: async ({ commit }, payload) => {
        try {
            let { data, status } = await EdificioService.put(payload)
            if (status === 200) {
                commit("UPDATE_EDIFICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El edificio del activo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el edificio del activo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_EDIFICIO: async ({ commit }, payload) => {
        try {
            let { status, data } = await EdificioService.delete(payload)
            if (status === 204) {
                commit("DELETE_EDIFICIO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El edificio del activo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_EDIFICIO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El edificio del activo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el edificio del activo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
